export * from './useAppDispatch'
export * from './useAppSelector'
export * from './useAppStore'
export * from './useBack'
export * from './useBackInStock'
export * from './useBannersClick'
export * from './useCinnamonProps'
export * from './useCreateOrder'
export * from './useLoadDialogValidations'
export * from './useModal'
export * from './usePlaceOrder'
export * from './useProductDetail'
export * from './useDialog'
export * from './usePushView'
export * from './useSearch'
export * from './useSessionGuard'

export * from './cart'
export * from './catalog'
export * from './categories'
export * from './categoriesnav'
export * from './filters'
export * from './linkedProducts'
export * from './login'
export * from './orders'
export * from './prefillCart'
export * from './recommendations'
export * from './suggestedItems'
export * from './summary'
export * from './templates'
export * from './workflow'

export const useLogAction = () => (text: string) =>
  // eslint-disable-next-line
  console.log('action executed', text)
